var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBackups = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.815 10.22C24.815 11.41 24.2666 12.4833 23.38 13.1833C22.7383 13.7083 21.91 14.0233 21.0116 14.0233C18.9233 14.0233 17.22 12.32 17.22 10.2317C17.22 9.19335 17.64 8.24834 18.34 7.56001V7.54834C19.0283 6.86001 19.9733 6.42834 21.0116 6.42834C23.1116 6.42834 24.815 8.13168 24.815 10.22Z",
    fill: "#FF9203"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5433 21.8517C22.3183 22.9717 20.7433 23.59 19.075 23.59H6.96497C3.7683 23.3567 2.34497 20.895 2.34497 18.7017C2.34497 16.7417 3.47664 14.5717 5.96164 13.965C4.87664 9.78834 6.9533 6.87167 9.37997 5.48334C11.7833 4.11834 15.1666 3.89667 17.71 5.77501C17.4883 5.93834 17.29 6.11334 17.0916 6.31167L16.59 6.83667V6.90667C15.8666 7.85167 15.47 9.00667 15.47 10.22C15.47 13.2767 17.9666 15.7617 21.0233 15.7617C22.2833 15.7617 23.5083 15.33 24.465 14.5483C24.64 14.4083 24.815 14.2567 24.9666 14.0933C26.1216 16.52 25.9583 19.74 23.5433 21.8517Z",
    fill: "url(#paint0_linear_640_6523)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6523",
    x1: 2.34497,
    y1: 12.5631,
    x2: 25.6612,
    y2: 12.5631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBackups, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/backups.4900b992.svg";
export { ForwardRef as ReactComponent };